import { useIntl } from "gatsby-plugin-intl"
import { extractOptionalTranslation, extractVersionFromGeoVariable } from "./VariableDropdown"
import * as React from "react"
import { AppState } from "../data/redux-state"
import { applyDerivToTitle } from "../utils/derivParam"
import { applyCumulToTitle } from "../utils/cumulParam"

export const AboveChart = (props: {
  appState: AppState
  xRange: Date[]
  data: any
}) => {
  const intl = useIntl()
  const metadata = props.appState.sourceJson?.FileMetadata
  const rawDataTitle = metadata?.DataTitle ?? "-"
  const dataTitle = extractOptionalTranslation({
    parentKey: "dataTitle",
    subKey: rawDataTitle,
    intl,
  })

  const from = props.xRange[0].getFullYear()
  const to = props.xRange[1].getFullYear()
  
  const geoVariable = props.appState.geoVariable
  const version = extractVersionFromGeoVariable(geoVariable)
  
  const urlParams = new URLSearchParams(window.location.search)
  const chartTitleParam = urlParams.get("chartTitle")

  let chartLegend = chartTitleParam ??
    applyCumulToTitle(applyDerivToTitle(
      dataTitle +
      " (" +
      from +
      " " +
      intl.formatMessage({ id: "chart.to" }) +
      " " +
      to +
      ")"
    )) +
    (version && version !== "public" ? ` - ${version}` : "")

  return (
    <div
      style={{
        fontFamily: "HKGrotesk",
        marginBottom: "2px",
        marginLeft: "15%",
        width: "75%",
        textAlign: "center",
      }}
      className={"above_chart_title"}
    >
      {chartLegend}
    </div>
  )
}
